import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.3 });
  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[2px] origin-left"
      style={{
        scaleX,
        zIndex: 10000,
        background: "linear-gradient(90deg, var(--crimson-bright), var(--gold-bright))",
        boxShadow: "0 0 12px rgba(201,162,75,0.6)",
      }}
    />
  );
}
